import {
  AkaAdvicePriceFormValues,
  AkaDeathAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";

import { BackendProductInfo } from "Components/Features/CheckPrice/Products/productConstants";
import { DeathPriceRequest } from "Store/akaAdvice/interfaces/AdviceProductPriceRequests";
import { AdvicePriceCalculationRequest } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const mapToDeathPriceReq = (
  formValues: AkaAdvicePriceFormValues,
): {
  productPriceUrl: AdvicePriceCalculationRequest["productPriceUrl"];
  insuranceName: AdvicePriceCalculationRequest["insuranceName"];
  data: DeathPriceRequest;
} => {
  const { deathInsuredSumSlider }: AkaDeathAdviceFormValues = formValues;
  return {
    productPriceUrl: BackendProductInfo.DEATH.priceReqUrl,
    insuranceName: INSURANCE_NAME_VALUE.DEATH,
    data: {
      insuredSum: deathInsuredSumSlider as number,
    } as DeathPriceRequest,
  };
};
